/**
 * Validate if product is ready for accommodation residents step
 */
export default defineNuxtRouteMiddleware((to) => {
    const { product } = useProduct(to);
    const { firstStepRoute } = useFlow(to);

    if (product.value.config.type === 'Accommodation') {
        const productAccommodation = product.value as ProductAccommodation;
        if (!productAccommodation.dateFrom || !productAccommodation.dateUntil) {
            return navigateTo(firstStepRoute.value);
        }
    }
    else {
        return abortNavigation();
    }
});
